import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const valueMap: Record<string, string> = {
  internal: 'Internal',
  external: 'External',
  cloud: 'Cloud',
  repository: 'Repository',
  application: 'Application',
  llm: 'LLM',
};

const valueMapInverse = invertMap(valueMap);

/**
 * Reusable field definition for Asset attack surface
 * Translates between API lowercase values and UI capitalized values
 */
export const AssetSurface: SimpleFilterDefinition = {
  apiField: 'attackSurface',
  uiField: 'Attack Surface',
  inputType: 'dropdown',
  getAvailableValues: () =>
    Promise.resolve([
      'Internal',
      'External',
      'Cloud',
      'Repository',
      'Application',
      'LLM',
    ]),
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Attack Surface',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'attackSurface',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: getValueFromSimpleFilter(valueMapInverse, simpleFilter),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
